var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadVsquareswitchOff = function SvgFadVsquareswitchOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.377 231c3.53 0 6.39-2.88 6.39-6.428V31.622c0-3.55-2.863-6.427-6.39-6.427H70.39c-3.53 0-6.391 2.88-6.391 6.428v192.95c0 3.55 2.863 6.427 6.39 6.427h114.987z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.995 216.333c3.316 0 6.005-2.84 6.005-6.354V46.354c0-3.51-2.693-6.354-6.005-6.354h-83.99C82.69 40 80 42.841 80 46.354v163.625c0 3.51 2.693 6.354 6.005 6.354h83.99z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.017 135.764c1.766 0 3.197-1.789 3.197-3.996v-8.008c0-2.207-1.43-3.996-3.197-3.996H92.75c-1.765 0-3.197 1.79-3.197 3.996v8.008c0 2.207 1.43 3.996 3.197 3.996h70.267zm0 32.726c1.766 0 3.197-1.789 3.197-3.996v-8.008c0-2.207-1.43-3.996-3.197-3.996H92.75c-1.765 0-3.197 1.789-3.197 3.996v8.008c0 2.207 1.43 3.996 3.197 3.996h70.267zm0 31.726c1.766 0 3.197-1.79 3.197-3.997v-8.007c0-2.207-1.43-3.996-3.197-3.996H92.75c-1.765 0-3.197 1.788-3.197 3.996v8.007c0 2.207 1.43 3.997 3.197 3.997h70.267z",
    fill: "#000"
  }))));
};
export { SvgFadVsquareswitchOff as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-vsquareswitch-off.8285943c.svg";